import React, { useState } from "react";
import { ChevronDownSvg } from "./svgs";

const CartItemDropdown = ({
  children,
  chevronLeft,
  buttonContent,
  alwaysFullWidth,
  displayVerticalLine,
}) => {
  const [open, setOpen] = useState(false);
  const internalDisplayVerticalLine =
    displayVerticalLine === false ? false : true;
  return (
    <>
      <div
        className={
          "row no-gutters wbmcil-dropdown-button" +
          (chevronLeft ? " wbmcil-chevron-left" : " wbmcil-chevron-right") +
          (alwaysFullWidth ? " wbmcil-full-width" : "")
        }
      >
        <div className="offset-6 col-6">
          <button
            onClick={() => setOpen(!open)}
            className={internalDisplayVerticalLine ? null : "no-vert-line"}
          >
            <ChevronDownSvg
              className={"wbmcil-chevron" + (open ? " wbmcil-is-open" : "")}
            />
            {internalDisplayVerticalLine && (
              <div className="wbmcil-chevron-d"></div>
            )}
            {buttonContent}
          </button>
        </div>
      </div>
      {open && children && (
        <div className="wbmcil-dropdown-wrapper">{children}</div>
      )}
    </>
  );
};

export default CartItemDropdown;
